import React from "react";

const AdminBookList = () =>{
    return (
        <div>Add and Edit Books</div>
    )
}
export default AdminBookList;